/**
 * 代码生成类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 代码生成类型
 */
enum GSPBillCodeGenerateType {
    /**
     * 未设置
     */
    none = 0,

    /**
     * 系统生成
     */
    genersoft = 1,

    /**
     * 手工生成
     */
    hand = 2,

    /**
     * 自增
     */
    increment = 3,
}

export { GSPBillCodeGenerateType };

